(function($) {

  $(document).ready(function(){
    if ( $('.home-hero').length ) {
      heroSlider();
    }
  });


  // ===========================================================
  //                 hero Slider
  // ===========================================================
  function heroSlider() {
    var $rootElem       = $('.home-hero-wrapper');
    var mainSlider      = '.home-hero-wrapper .hero-slider-container';
    var navSlider       = '.home-hero-wrapper .slide-bar';

    // initially hide the slider with css
    // when slider is fully loaded, show the slider
    // -----------------------------------------------------------
    $rootElem.show();

    $(mainSlider).slick({
        slidesToShow: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 6000,
        adaptiveHeight: false,
        fade: true,
        slide: '.slide',
    });

    $(mainSlider).find('.slick-dots').wrap( "<div class='slick-dot-wrap'></div>" );



    // var time = 2;
    // var $bar,
    //     $slick,
    //     isPause,
    //     tick,
    //     percentTime;
    //
    //
    // $bar = $('.slider-progress .progress');

    // $('.hero-slider-container div.copy').on({
    //   mouseenter: function() {
    //     isPause = true;
    //   },
    //   mouseleave: function() {
    //     isPause = false;
    //   }
    // });


    // function startProgressbar() {
    //   resetProgressbar();
    //   percentTime = 0;
    //   isPause = false;
    //   tick = setInterval(interval, 50);
    // }
    //
    // function interval() {
    //   if (isPause === false) {
    //     percentTime += 1 / (time+0.1);
    //
    //     // console.log(percentTime);
    //
    //     $bar.css({
    //       width: percentTime + "%"
    //     });
    //
    //     if (percentTime >= 100) {
    //       $(mainSlider).slick('slickNext');
    //     }
    //   }
    // }


    // slider counter
    // =======================================================
    var slideLength = $rootElem.find('.slide').length;
    var totalSlideElem = $rootElem.find('.total-slide');
    var SlideNumElem = $rootElem.find('.current-num');
    totalSlideElem.text(slideLength);




    // reset progress bar on slide change if user swipes / uses arrow keys
    $(mainSlider).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      //startProgressbar();
      SlideNumElem.text(nextSlide + 1);
    });

    // function resetProgressbar() {
    //   $bar.css({
    //     width: 0+'%'
    //   });
    //
    //   clearTimeout(tick);
    // }
    //
    // startProgressbar();

  }


}(jQuery));



// WEBPACK FOOTER //
// ./assets/js/home-hero-slider.js